import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
function t() {
  for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
    r[_key] = arguments[_key];
  }
  return Array.from(new Set(r.flatMap(function (n) {
    return typeof n == "string" ? n.split(" ") : [];
  }))).filter(Boolean).join(" ");
}
export { t as classNames };